import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default function IssueView({ issue, isModalVisible, handleShowB }) {
    return (
        <Modal
            isOpen={isModalVisible}
            toggle={handleShowB}
            className="modal-dialog-scrollable"
            backdrop="static"
        >
            <ModalHeader toggle={handleShowB}>Issue Details</ModalHeader>
            <ModalBody className="bg-white">
                {!issue ? (
                    <div className="text-center py-3 text-muted">No issue selected</div>
                ) : (
                    <div className="issue-view">
                        <div className="d-flex align-items-start justify-content-between mb-3">
                            <div>
                                <div className="text-muted small">TT ID</div>
                                <h5 className="mb-0">#{issue.id}</h5>
                            </div>
                            <span className={`badge ${issue.status_class}`}>{issue.status_name}</span>
                        </div>

                        <table className="table table-bordered mb-0">
                            <tbody>
                                <tr>
                                    <th width="32%">Title</th>
                                    <td>{issue.title || "-"}</td>
                                </tr>
                                <tr>
                                    <th>Description</th>
                                    <td style={{ whiteSpace: "pre-wrap" }}>{issue.remark || "-"}</td>
                                </tr>
                                <tr>
                                    <th>Feedback</th>
                                    <td style={{ whiteSpace: "pre-wrap" }}>{issue.note || "-"}</td>
                                </tr>
                                <tr>
                                    <th>Assign By</th>
                                    <td>{issue.assign_by || "-"}</td>
                                </tr>
                                <tr>
                                    <th>Assign Date</th>
                                    <td>{issue.assign_date_txt || "-"}</td>
                                </tr>
                                <tr>
                                    <th>Solve At</th>
                                    <td>{issue.solve_at_txt || "-"}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
}
